const dadlAppraisalValuesTemplate = `<!DOCTYPE html>
<html>
  <head>
  </head>
  <body>
    <div id="appraisalValues">
    <div class="heading"><h6>Appraisal &nbsp; Value &nbsp; (Values &nbsp; in &nbsp;{{currency}} )</h2></div>
    <table>
        <tr>
          <th></th>
          <th></th>
          <th>% Change</th>
          <th>Effective Date Of Value</th>
          <th>Dervative</th>
        </tr>
        <tr>
          <td class="leftAlign">Current Debt Value</td>
          <td class ="rightAlign">{{currencySymbol}}{{ currentDebtValue}}</td>
          <td></td>
          <td>{{currentDate}}</td>
          <td class ="rightAlign">{{currencySymbol}}{{ derivative}}</td>
        </tr>
        <tr>
          <td class="leftAlign">Last Debt Value</td>
          <td class ="rightAlign">{{currencySymbol}}{{ lastDebtValue}}</td>
          <td class ="rightAlign">{{lastPercentageChange}}</td>
          <td>{{lastDate}}</td>
          <td></td>
        </tr>
        
      </table>
    </div>
  </body>
</html>
`;
export default dadlAppraisalValuesTemplate;


// <style>
// body {
//   font-family: Roboto, Helvetica, Arial, sans-serif;
// }
// table,
// th,
// td {
//   border: none;
//   padding-top: 10px;
// }
// table {
//   width: 100%;
//   border-radius: 3px !important;
// }
// th,
// td {
//   padding: 15px;
// }
// .border {
//   width: 100%;
//   border: 0.5px solid #263746;
//   border-radius: 3px;
// }

// .heading {
//   margin: 0 !important;
//   background-color: #263746;
//   color: #fff;
//   padding: 10px;
// }

// th > .leftAlign {
//   align-items: left !important;
//   justify-content: left !important;
//   text-align: left !important;
// }
// </style>